import React, {Component} from 'react';
import {Field} from 'redux-form';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {intlShape, injectIntl} from 'react-intl';
import { refreshCaptcha } from './CaptchaActions';

import _ from 'lodash';
import TextField from '../TextField/TextField';
import {isEmpty, getValidationError} from '../FormElement/FormElementUtils';
import './captcha.less';

const LOCALE_PREFIX = 'components/Captcha/captcha';

export class Captcha extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        captchaImgUrl: PropTypes.string,
        captchaAudioUrl: PropTypes.string,
        reloadTheCaptcha: PropTypes.func,
    };

    captchaReload = (event) => {
        event.preventDefault();
        const {reloadTheCaptcha} = this.props;
        return reloadTheCaptcha();
    };

    playCaptchaAudio = (event) => {
        const captchaAudio = document.getElementById('captchaPlay');
        captchaAudio.load();
        captchaAudio.play();

    };

    render() {
        const {intl, captchaImgUrl, captchaAudioUrl} = this.props;
        return (
            <div id="captcha" className="form-field">
                <img src={captchaImgUrl} alt="security Image" id="captchaImageDisplay" />
                <div className="row-fluid">
                    <div id="captchaField" className="span16">
                        <Field
                            type="text"
                            id="captchaInput"
                            name="captchaInput"
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="off"
                            component={TextField}
                            label={intl.formatMessage({id: `${LOCALE_PREFIX}.captcha-placeholderEnterCode`})}
                            validate={[isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.captcha-isNull`}))]}
                        />
                    </div>
                    <div className="span">
                        <a href="#"
                            data-automation-id="refreshCaptcha"
                            className="captchaRefresh refresh btn btn-primary inputField"
                            name="refreshCaptcha"
                            id="refreshCaptcha"
                            onClick={this.captchaReload}
                        />
                        <div className="audio testing btn btn-primary captchaAudio inputField" tabIndex="0"
                            onClick={this.playCaptchaAudio}
                            onKeyUp={this.playCaptchaAudio}
                        >
                            <audio id="captchaPlay"
                                src={captchaAudioUrl}
                                preload="auto"
                            />

                        </div>
                    </div>

                </div>
            </div>

        );
    }

}

export const mapDispatchToProps = dispatch => ({
    reloadTheCaptcha() {
        dispatch(refreshCaptcha());
    }
});

export const mapStateToProps = state => ({
    captchaImgUrl: _.get(state, 'serverData.captchaImgUrl'),
    captchaAudioUrl: _.get(state, 'serverData.captchaAudioUrl')
});


export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Captcha));
